/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { findIndex, forEach, isEmpty, sortBy } from "lodash";
import { deleteInvoices, getInvoiceList, deleteInvoicesList, createTaxInvoicesIssue } from "../../../apis/invoices";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { dateToFormat, getDay } from "../../../utils/date";
import { getParams } from "../../../utils/params";
import { autoHyphen } from "../../../utils/replace";
import { restoreComma, transformComma } from "../../../utils/validator/comma";
import TradeInvoice from "./TradeInvoice";
import TaxInvoiceCreate from "../Tax/TaxInvoiceCreate";
import useForm from "../../../hooks/useForm";
import { useHistory } from "react-router-dom";
import systemAlert from "../../../utils/systemAlert";
import Icon from "../../../components/Icon";
import ToolTip from "../../../components/ToolTip/ToolTip";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import { viewLoading } from "../../../utils/loading";
import { isAdmin, isManagerCompany, isManagingType } from "../../../utils/auth";
import { cleanObj } from "../../../utils/cleanObj";
import { toast } from "../../../utils/toast";
import { judgeRegNumTyp } from "../../../utils/tax-invoice-type";
import { clientPreview } from "../../../utils/client";
import { preventEvent } from "../../../utils/element";
import { get } from "lodash";


const SalesInvoice = ({
  isTableHide = false,
  open,
  setOpen,
  invoiceType,
  setInvoiceType,
  formType,
  setFormType,
  permission,
  excelDown = () => { }
}) => {
  const history = useHistory();
  const [sortFields, setSortFields] = useState([
    { key: 'createdTime', order: 'desc' },
    { key: 'writeDate', order: '' },
    { key: 'taxAmt', order: '' },
    { key: 'totalAmt', order: '' },
    { key: 'supplyAmt', order: '' },
  ]);
  const [fields, setFields] = useState([]);
  const [filters] = useState([
    { title: "조회기간 (작성일자)", key: "range.writeDate", type: "customdatepicker" },
    { title: "거래처명", key: 'search.byrCorpName' }
  ]);
  const [rowData, setRowData] = useState({});
  // 세금계산서 발행
  const [taxInvoiceOpen, setTaxInvoiceOpen] = useState(false);
  const [taxInvoiceData, setTaxInvoiceData] = useState({});

  useEffect(() => {
    setFields([
      { title: "작성일자", key: "writeDate", className: 'nowrap', type: 'date', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "등록일자", key: "createdTime", className: 'nowrap', type: 'date', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "상호", key: "byrCorpName",
        onValue: (value, field, data) => {
          return <p
            onClick={(e) => {
              preventEvent(e);
              data?.client && clientPreview(data.client.companyAccountIdx);
            }}

          >{value}</p>;
        }
      },
      { title: "대표자명", key: "byrRepName" },
      {
        title: "사업자번호",
        key: "byrBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      {
        // title: "대표품목",
        title: "품목",
        key: "invoiceItems[0].prodName",
        onValue: (value, field, form) => {
          let itemsLabels = '';
          let items = "";
          if (!isEmpty(form.invoiceItems)) {
            forEach(form.invoiceItems, (item) => {
              if (item.order <= 1) {
                items =
                  form.invoiceItems.length > 1
                    ? `${item.prodName} 외 ${form.invoiceItems.length - 1}건`
                    : item.prodName;
              }
              const unit = item.unit || '개';
              itemsLabels += `${item.prodName}: ${transformComma(item.unitCost)}원 x ${item.qty} ${unit} = ${transformComma(item.supplyCost + item.taxAmt)}원 (부가세포함) \n`;
            });
          }

          return <>{items}<ToolTip
            position="bottom"
            tooltiptext={itemsLabels}
          /></>;
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        className: 'nowrap',
        onValue: (value) => {
          return transformComma(value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "세액",
        key: "taxAmt",
        className: 'nowrap',
        onValue: (value) => {
          return transformComma(value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "합계금액",
        key: "totalAmt",
        className: 'nowrap',
        onValue: (value) => {
          return transformComma(value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "발행여부",
        key: "mappedTaxInvoices",
        onValue: (value) => {
          let issue = "";
          if (isEmpty(value)) {
            issue = "부";
          } else {
            const invoiceType = get(value, "[0].invoiceType", "");
            switch (invoiceType) {
              case 'tax_invoice':
                issue = "세금계산서";
                break;
              case 'receipt':
                issue = "계산서";
                break;
              default:
                issue = "세금계산서";
                break;
            }
            // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함

          }

          return issue;
        },
      },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      }
    ]);
  }, [sortFields]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    reSubmit,
    // reSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm(
    {
      search: {
        byrCorpName: ""
      },
      range: {
        writeDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date
      },
      order: [
        { createdTime: 'desc' }
      ],
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  useEffect(() => {
    excelDown({ form });
  }, [form]);

  // 보이는 전체 거래명세서 세금계산서로 발행하기
  const allTaxInvoiceCreate = async () => {
    let isError = false;
    viewLoading(`세금계산서 발행 준비 중입니다.`);
    const targetList = list.filter((item) => isEmpty(item.mappedTaxInvoices));

    const bodys = targetList.map((invoice) => {
      const itemList = invoice.invoiceItems.map(item => ({
        date: item.trDate,
        trMonth: dateToFormat(item.trDate, "M"),
        trDate: dateToFormat(item.trDate, "D"),
        prodName: item.prodName,
        unit: item.unit,
        qty: item.qty,
        unitCost: transformComma(item.unitCost),
        supplyCost: transformComma(item.supplyCost),
        taxAmt: transformComma(item.taxAmt),
        remark: item.remark,
      }));


      for (const obj of itemList) {
        if (isEmpty(obj.trMonth)) { isError = true; toast.error("품목 거래 월을 입력해주세요"); }
        if (isEmpty(obj.trDate)) { isError = true; toast.error("품목 거래 일을 입력해주세요"); }
        if (isEmpty(obj.prodName)) { isError = true; toast.error("품목명을 입력해주세요"); }
        if (isEmpty(obj.supplyCost)) { isError = true; toast.error("공급가액을 계산해주세요"); }
        if (isEmpty(obj.taxAmt) && invoice.taxType !== 'tax_free') { isError = true; toast.error("공급가액을 계산해주세요"); };
      }

      const body = {
        invoiceIdx: !isEmpty(invoice) ? [invoice.idx] : "",
        etxivClsfCd: invoice.taxType === 'tax_free' ? '03' : '01',
        etxivKndCd: invoice.taxType === 'small_biz' ? '02' : '01',
        etxivDmnrClsfCd: judgeRegNumTyp(invoice.byrBizNo),
        emailYn: !isEmpty(invoice.supEmail) || !isEmpty(invoice.byrEmail1) ? 'Y' : 'N', //optional
        splrChrgEmlAdr: invoice.supEmail, // optional
        wrtDt: dateToFormat(invoice.writeDate.toString(), 'YYYYMMDD'),
        rmrkCntn: invoice.memo,
        recApeClCd: invoice.recApeClCd || "02", // 모두 청구
        splrTxprDscmNo: invoice.supBizNo, // required
        splrMpbNo: invoice.supBizSubNo, // optional
        splrTnmNm: invoice.supCorpName, // required
        splrRprsFnm: invoice.supRepName, // required
        splrPfbAdr: invoice.supAddress, // optional
        splrBcNm: invoice.supBizCategory, // optional
        splrEmlAdr: invoice.supEmail, // optional
        splrItmNm: invoice.supBizItem, // optional
        dmnrTxprDscmNo: invoice.byrBizNo, // required
        dmnrTnmNm: invoice.byrCorpName, // required
        dmnrRprsFnm: invoice.byrRepName, // required
        dmnrPfbAdr: invoice.byrAddress, // optional
        dmnrBcNm: invoice.byrBizCategory, // optional
        dmnrItmNm: invoice.byrBizItem, // optional
        dmnrMchrgEmlAdr: invoice.byrEmail1, // optional
        dmnrMchrgEmlAdr2: invoice.byrEmail2 || "", // optional
        lsatInfrBizSVOList: itemList.map((item) => ({
          lsatSplMm: String(item.trMonth),
          lsatSplDd: String(item.trDate),
          lsatNm: String(item.prodName),
          lsatRszeNm: String(item.unit),
          lsatQty: String(item.qty),
          lsatUtprc: restoreComma(item.unitCost),
          lsatSplCft: restoreComma(item.supplyCost),
          lsatTxamt: restoreComma(item.taxAmt),
          lsatRmrkCntn: String(item.remark),
        }))
      };
      cleanObj(body);
      return body;
    });

    if (isError) {
      setTimeout(() => {
        viewLoading(false);
        systemAlert('세금계산서를 발행 할 수 없는 거래명세서가 포함되어있습니다.');
      }, 300);
      return;
    }
    try {

      for (const body of bodys) {
        viewLoading(`${body.dmnrTnmNm}에게 세금계산서 발행중입니다.`);
        await createTaxInvoicesIssue(body);
      }
    } catch (error) {
      viewLoading(false);

    }

    reSubmit();
    viewLoading(false);
  };

  const submit = (params) => {
    setIsLoading(true);
    getInvoiceList("sales", { ...getParams(params) })
      .then((res) => {
        const { totalCount, invoices, comment } = res.data;
        const transList = invoices.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }));

        setList(transList);
        setTotal(totalCount);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOnRowClick = (data, e) => {
    const { tagName } = e.target;
    if (tagName !== "TR" && tagName !== "TD") return;

    setRowData(data);
    setInvoiceType("sales");
    if (isEmpty(data.mappedTaxInvoices) && permission.level > 1) {
      setFormType("modify");
    } else {
      setFormType("detail");
    }
    setSelectedList([]);
    setOpen(true);
  };

  const getCheckboxDisabled = (data) => {
    let disabled = false;

    if (!isEmpty(selectedList)) {
      if (data.clientIdx !== selectedList[0].clientIdx) {
        disabled = true;
      }
    }

    return disabled;
  };

  const createInvoice = () => {

    const sortSelectedList = sortBy(selectedList, ["writeDate"]);
    const invoiceIdx = [];
    const itemList = [];

    for (const obj of sortSelectedList) {
      invoiceIdx.push(obj.idx);
      for (const items of obj.invoiceItems) {
        itemList.push({
          date: items.trDate,
          trMonth: dateToFormat(items.trDate, "M"),
          trDate: dateToFormat(items.trDate, "D"),
          prodName: items.prodName,
          unit: items.unit,
          qty: items.qty,
          unitCost: transformComma(items.unitCost),
          supplyCost: transformComma(items.supplyCost),
          taxAmt: transformComma(items.taxAmt),
          remark: items.remark,
        });
      }
    }

    const sortItemList = sortBy(itemList, ["date"]);
    const invoiceData = {
      invoiceIdx,
      byrBizNo: sortSelectedList[0].byrBizNo,
      byrBizSubNo: sortSelectedList[0].byrBizSubNo,
      byrCorpName: sortSelectedList[0].byrCorpName,
      byrRepName: sortSelectedList[0].byrRepName,
      byrAddress: sortSelectedList[0].byrAddress,
      byrEmail1: sortSelectedList[0].byrEmail1,
      byrEmail2: sortSelectedList[0].byrEmail2,
      byrBizCategory: sortSelectedList[0].byrBizCategory,
      byrBizItem: sortSelectedList[0].byrBizItem,
      supAddress: sortSelectedList[0].supAddress,
      supBizCategory: sortSelectedList[0].supBizCategory,
      supBizItem: sortSelectedList[0].supBizItem,
      supBizNo: sortSelectedList[0].supBizNo,
      supBizSubNo: sortSelectedList[0].supBizSubNo,
      supByrType: sortSelectedList[0].supByrType,
      supCorpName: sortSelectedList[0].supCorpName,
      supEmail: sortSelectedList[0].supEmail,
      supRepName: sortSelectedList[0].supRepName,
      writeDate: sortSelectedList[0].writeDate,
      taxType: sortSelectedList[0].taxType,
      itemList: sortItemList,
      clientIdx: sortSelectedList[0].clientIdx
    };
    setTaxInvoiceOpen(true);
    setTaxInvoiceData(invoiceData);
  };

  const headerButtonConfig = [
    ...isAdmin() ? [{
      label: '보이는 거래명세서 전체 삭제',
      color: 'red',
      action: () => {
        const isMappedTaxInvoices = list.some((item) => { return !isEmpty(item.mappedTaxInvoices); });
        const invoiceIdxes = list.map(i => i.idx);

        systemAlert(
          isMappedTaxInvoices ? '발행여부가 있는 거래명세서가 존재합니다.\n 세금계산서는 별도의 수정발행이 필요합니다.\n 거래명세서를 삭제 하시겠습니까?' : `${list.length}개 거래명세서를 모두 삭제하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '계속',
              onClick: () => {
                viewLoading('거래명세서를 삭제중 입니다.');
                deleteInvoicesList(invoiceIdxes)
                  .then(() => {
                    viewLoading(false);
                    submit(form);
                    setSelectedList([]);
                    systemAlert('모두 삭제 되었습니다.');
                  });
              }
            }
          ]
        });
      },
      disabled: isLoading || isEmpty(list)
    }] : [],
    ...(isManagingType() || isAdmin() || isManagerCompany()) ? [{
      label: '보이는 거래명세서 세금계산서 일괄 발행',
      action: () => {
        // const isMappedTaxInvoices = list.some((item) => { return !isEmpty(item.mappedTaxInvoices); });
        const targetList = list.filter((item) => isEmpty(item.mappedTaxInvoices));
        if (targetList.length === 0) {
          return systemAlert('전체 발행 가능한 거래명세서가 없습니다.(발행여부 있는 거래명세서 제외)\n중복발행이 필요한 경우 별도 선택해서 발행해주세요.');
        }
        systemAlert(
          `${targetList.length}개(발행여부 있는 거래명세서 제외) 거래명세서를 모두 세금계산서 발행하시겠습니까?\n거래명세서 1건당 한건의 세금계산서가 발행되며 시간이 걸릴 수 있습니다.`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '계속',
              onClick: () => {
                allTaxInvoiceCreate();
              }
            }
          ]
        });

      },
      disabled: isLoading || isEmpty(list)
    }] : [],
    {
      label: '세금계산서 발행',
      color: 'line',
      action: () => {
        const isMappedTaxInvoices = selectedList.some((item) => { return !isEmpty(item.mappedTaxInvoices); });
        if (isMappedTaxInvoices) {
          systemAlert('발행여부가 있는 거래명세서가 존재합니다. 계속 세금계산서를 발행하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '계속',
                onClick: () => {
                  createInvoice();
                }
              }
            ]
          });
        } else {
          createInvoice();
        }

      },
      disabled: isEmpty(selectedList)
    }
  ];

  const rowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        type: "delete",
        className: "ml-4",
        isHide: (data) => {
          return !isEmpty(data.mappedTaxInvoices);
        },
        action: (data) => {
          let message = `해당 거래명세서를 삭제하시겠습니까?`;
          if (data.taxInvoiceIdx) {
            message = `해당 거래명세서는 세금계산서로 발행된 이력이 있습니다.
            거래명세서가 제거될경우 채권채무 계산에 오류가 발생할수 있습니다.
            중복된 거래명세서의 경우 가장 최근 발행된 거래명세서를 제거해주세요. ${message}`;
          }
          // data.taxInvoiceIdx
          systemAlert(message, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteInvoices(data.idx).then(() => {
                    submit(form);
                    setSelectedList([]);
                  });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };

  return (
    <>
      {!isTableHide &&
        <>
          <Filters
            isLoading={isLoading}
            filters={filters}
            submit={filterSubmit}
            form={form}
            onChange={handleOnChange} />
          <ControlTable
            isControl={permission.level > 1}
            isHideAllCheck
            isLoading={isLoading}
            fields={fields}
            sortField={sortFields.find((field) => !isEmpty(field.order))}
            list={list}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            total={total}
            selectedList={selectedList}
            setSelected={setSelectedList}
            onSelect={handleOnRowClick}
            checkboxDisabled={getCheckboxDisabled}
            buttons={permission.level > 1 ? headerButtonConfig : []}
            submit={handleSubmit}
            rowBtn={permission.level > 1 ? rowBtnConfig : {}}
          />
        </>
      }
      <TradeInvoice
        open={open}
        setOpen={setOpen}
        supByrType={invoiceType}
        setInvoiceType={setInvoiceType}
        list={rowData}
        setList={setRowData}
        formType={formType}
        setFormType={setFormType}
        submit={() => submit(form)}
        permission={permission}
      />
      {taxInvoiceData && taxInvoiceOpen && (
        <TaxInvoiceCreate
          // submit={reSubmit}
          submit={() => {
            window.location.reload();
          }}
          open={taxInvoiceOpen}
          setOpen={setTaxInvoiceOpen}
          supByrType={'sales'}
          data={taxInvoiceData}
          list={[]}
        />
      )}
    </>
  );
};

export default SalesInvoice;
